const TRC_PAGE_CATEGORIES = Object.freeze({
	LESSON_PLANS: 'LESSON PLANS',
	VIDEOS: 'TRC VIDEO',
	RESOURCES: 'RESOURCES',
	VIEW_ALL: 'VIEW ALL',
	PARTNERS: 'PARTNERS',
	SEARCH: 'SEARCH RESULTS'
});

export default TRC_PAGE_CATEGORIES;
